import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import LabSubscriberForm from './LabSubscriberForm';
import { labSubscriberService } from 'services/api';
import { ILabSubscriber } from 'interfaces';

export const EditLabSubscriber = () => {
  const translationPrefix = 'pages.lab-subscriber-settings.edit';
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [labSubscriber, setLabSubscriber] = useState<ILabSubscriber | null>(null);

  useEffect(() => {
    if (id) {
      labSubscriberService.get(id).then(setLabSubscriber);
    }
  }, [id]);

  const updateLabSubscriber = async (values: {
    company_name: string;
    is_active: boolean;
    endpoint: string;
    suppliers: number[];
  }) => {
    if (!id) return;
    await labSubscriberService.update(id, {
      company_name: values.company_name,
      endpoint: values.endpoint,
      is_active: values.is_active,
      suppliers: values.suppliers ?? []
    });
    navigate('..');
  };

  if (!labSubscriber) return null;

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <LabSubscriberForm labSubscriber={labSubscriber} onSubmit={updateLabSubscriber} />
    </TenantPage>
  );
};

export default EditLabSubscriber;
